var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9792 5.33398C24.9925 5.33398 19.3125 11.014 19.3125 18.0007C19.3125 24.854 24.6725 30.4006 31.6592 30.6406C31.8725 30.614 32.0858 30.614 32.2458 30.6406C32.2992 30.6406 32.3258 30.6406 32.3792 30.6406C32.4058 30.6406 32.4058 30.6406 32.4325 30.6406C39.2592 30.4006 44.6192 24.854 44.6458 18.0007C44.6458 11.014 38.9658 5.33398 31.9792 5.33398Z",
    fill: "#78C257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.57 37.7337C38.13 32.7737 25.9967 32.7737 18.5033 37.7337C15.1167 40.0003 13.25 43.067 13.25 46.347C13.25 49.627 15.1167 52.667 18.4767 54.907C22.21 57.4137 27.1167 58.667 32.0233 58.667C36.93 58.667 41.8367 57.4137 45.57 54.907C48.93 52.6403 50.7967 49.6003 50.7967 46.2937C50.77 43.0137 48.93 39.9737 45.57 37.7337ZM37.1967 48.6937C37.97 49.467 37.97 50.747 37.1967 51.5203C36.7967 51.9203 36.29 52.107 35.7833 52.107C35.2767 52.107 34.77 51.9203 34.37 51.5203L32.0233 49.1737L29.6767 51.5203C29.2767 51.9203 28.77 52.107 28.2633 52.107C27.7567 52.107 27.25 51.9203 26.85 51.5203C26.0767 50.747 26.0767 49.467 26.85 48.6937L29.1967 46.347L26.85 44.0003C26.0767 43.227 26.0767 41.947 26.85 41.1737C27.6233 40.4003 28.9033 40.4003 29.6767 41.1737L32.0233 43.5203L34.37 41.1737C35.1433 40.4003 36.4233 40.4003 37.1967 41.1737C37.97 41.947 37.97 43.227 37.1967 44.0003L34.85 46.347L37.1967 48.6937Z",
    fill: "#78C257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenx);
export default __webpack_public_path__ + "static/media/greenx.5cdfbb4e779d57d87caeec3c64be9b9f.svg";
export { ForwardRef as ReactComponent };